module.exports = __webpack_public_path__ + "img/file-upload.ac8e23b2.svg";